import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Button,
} from '@chakra-ui/react';

type ImagePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  imagePreview: string;
};

export const ImagePreviewModal = ({
  isOpen,
  onClose,
  imagePreview,
}: ImagePreviewModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <img src={imagePreview} />
        </ModalBody>

        <ModalFooter>
          <Button variant="warning" mr={3} onClick={(): void => onClose()}>
            Loka
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
